module.exports = __webpack_public_path__ + "static/media/quote-assume.cff8df53.png";